

<template>
  <!-- <div>
    <div class="fullview">
      <div class="container-fluid">
        <div class="close"><img src="@/assets/acrypro/close_img.png" @click="closeAction"/></div>
        <p class="fw-bold" style="font-size: 28px;">プレビュー</p>
        <img class="imageViewer m-auto" :src="this.$store.state.previewImageArray[0]" />
        <div class="row">
            <div class="col justify-content-center pt-4">
              <button class="acry-btn-primary-normal btn-size" @click="okAction">OK</button>
            </div>
        </div>
      </div>
    </div>
  </div> -->

  <div class="modalback">
    <div class="modalcontent">
      <div class="close cursor-pointer"><img src="@/assets/acrypro/close.svg" @click="closeAction"/></div>
      <p class="fw-bold" style="font-size: 28px;">ご確認ください</p>
      <div class="row info px-3 py-1 text-start">
        <p class="fw-bold m-0">次へ進むと以下の変更ができなくなります</p>
        <p></p>
        <p class="m-0">・PNG、SVGデータの変更</p>
        <p class="m-0">・個数の変更</p>
        <p class="m-0">※変更したい場合はデザインを新規で作成する必要があります</p>
      </div>
      <div class="row">
        <div class="col justify-content-center pt-4">
          <button class="acry-btn-primary-normal btn-size fw-bold" @click="okAction">テキストを入れる</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "CartInAlertDialog",
  components: {},
  data() {
    return {
    };
  },
  created(){
  },
  methods:{
    okAction(){
      this.$store.state.cartInAlertDialogCallback();
      this.$store.commit("hideCartInDialog")
    },
    closeAction(){
      this.$store.commit("hideCartInDialog")
    }

  }
};
</script>

<style scoped lang="scss">
.modalback {
  z-index: 200;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modalcontent {
  position: relative;
  z-index: 201;
  width: 890px;
  height: 500px;
  padding: 40px;
  background-color: $background-white-color;
  border-radius: 8px;
}

.info{
  margin: 90px auto 40px auto;
  width: 550px;
  height: 150px;
  border-radius: 10px;
  background-color: $background-gray-color;
}


.fullview {
  width: 100%;
  height: 100%;
  background: #000000aa;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 50000;

  display: flex;
  align-items: center;
  justify-content: center;
}
.container-fluid {
  /* margin-right: auto;
  margin-left: auto;
  max-width: 300px;
  min-width: 300px;
  max-height: 200px;
  min-height: 200px; */
  width:559px;
  /* height:200px; */

  z-index: 10001;
  padding: 40px;
  background-color: #FEFEFE;
  border-radius: 8px;
}
.btn-size{
  width: 240px;
  height: 56px;
}
.close {
  position: absolute;
  width: 48px;
  right: 40px;
}

</style>
